export const noCodeBuilderReducers = {
  addStrategy: (state, action) => {
    state.strategy.push(action.payload);
  },
  deleteStrategyAtIndex: (state, action) => {
    state.strategy.splice(action.payload.inx, 1);
  },
  addStatement: (state, action) => {
    state.strategy[action.payload.inx].conditions.push(action.payload.data);
  },
  updateStatementAtIndex: (state, action) => {
    state.strategy[action.payload.mainInx].conditions[action.payload.inx] =
      action.payload.data;
  },
  deleteStatementAtIndex: (state, action) => {
    state.strategy[action.payload.mainInx].conditions.splice(
      action.payload.inx,
      1
    );
  },
  addThenAction: (state, action) => {
    state.strategy[action.payload.inx].if_action.steps.push(
      action.payload.data
    );
  },
  deleteThenActionAtIndex: (state, action) => {
    state.strategy[action.payload.mainInx].if_action.steps.splice(
      action.payload.inx,
      1
    );
  },
  updateThenActionAtIndex: (state, action) => {
    state.strategy[action.payload.mainInx].if_action.steps[action.payload.inx][
      action.payload.key
    ] = action.payload.value;
  },
  updateElseActionAtIndex: (state, action) => {
    state.strategy[action.payload.mainInx].else_action.steps[
      action.payload.inx
    ][action.payload.key] = action.payload.value;
  },
  addElseAction: (state, action) => {
    state.strategy[action.payload.inx].else_action.steps.push(
      action.payload.data
    );
  },
  deleteElseActionAtIndex: (state, action) => {
    state.strategy[action.payload.mainInx].else_action.steps.splice(
      action.payload.inx,
      1
    );
  },
  updateSelectedTargetAssets: (state, action) => {
    state.assets.push(action.payload);
  },
  deleteAssetAtIndex: (state, action) => {
    state.assets.splice(action.payload.inx, 1);
  },
  updateAll: (state, action) => {
    state.interval = action.payload?.interval ?? "";
    state.assets = action.payload?.assets ?? [];
    state.selectedAssets = action.payload?.selectedAssets ?? [];
    state.strategy = action.payload?.strategy ?? [];
    state.assetGroups = action.payload?.assetGroups ?? [];
  },
  updateInterval: (state, action) => {
    state.interval = action.payload;
  },
  clearNcbState: (state) => {
    state.interval = "";
    state.assets = [];
    state.strategy = [];
    state.isLoading = false;
    state.errors = {};
    state.selectedAssets = [];
    state.assetGroups = [];
  },
  updateIsLoading: (state, action) => {
    state.isLoading = action.payload;
  },
  setErrors: (state, action) => {
    state.errors = action.payload;
  },
  addSelectedTargetAssets: (state, action) => {
    state.assets = action.payload;
  },
  removeSelectedTargetAsset: (state, action) => {
    state.assets = state.assets.filter(
      (asset) => asset.symbol !== action.payload
    );
  },
  addSelectedAssets: (state, action) => {
    const newAsset = action.payload;
    const exists = state.selectedAssets.some(
      (asset) => asset?.symbol === newAsset?.symbol
    );
    if (!exists) {
      state.selectedAssets.push(newAsset);
    }
  },
  removeSelectedAssets: (state, action) => {
    state.selectedAssets = state.selectedAssets.filter(
      (asset) => asset.symbol !== action.payload
    );
  },
  addAssetGroups: (state, action) => {
    state.assetGroups.push(action.payload);
  },
  updateAssetGroups: (state, action) => {
    state.assetGroups = action.payload;
  },
  removeAssetGroups: (state, action) => {
    state.assetGroups.splice(action.payload, 1);
  },
  addAssetInGroup: (state, action) => {
    const { groupIndex, asset } = action.payload;
    state.assetGroups[groupIndex].assets.push(asset);
  },
  removeAssetInGroup: (state, action) => {
    const { groupIndex, assetIndex } = action.payload;
    state.assetGroups[groupIndex].assets.splice(assetIndex, 1);
  },
  removeAssetInAllGroup: (state, action) => {
    const allGroups = [];

    state.assetGroups.map((group) => {
      const assets = group.assets;
      const assetIndex = assets.findIndex(
        (asset) => asset.symbol === action.payload
      );
      if (assetIndex > -1) {
        group.assets.splice(assetIndex, 1);
      }

      if (group.assets.length > 0) {
        allGroups.push(group);
      }
    });

    state.assetGroups = allGroups;
  },
  updateAssetGroupName: (state, action) => {
    const { groupIndex, name } = action.payload;
    state.assetGroups[groupIndex].name = name;
  },
  setIsStrategyLoading: (state, action) => {
    state.isStrategyLoading = action.payload;
  },
};
